import Vue from "vue";

import "./styles/quasar.scss";
import "quasar/dist/quasar.ie.polyfills";
import iconSet from "quasar/icon-set/material-icons-round.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/material-icons-round/material-icons-round.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import { Quasar } from "quasar";
import { Dialog } from "quasar";
import { Notify } from "quasar";

Vue.use(Quasar, {
  plugins: {
    Dialog,
    Notify,
  },
  config: {},
  components: {
    /* not needed if importStrategy is not 'manual' */
  },
  directives: {
    /* not needed if importStrategy is not 'manual' */
  },
  animations: "all",

  iconSet: iconSet,
});
